import { useCallback } from "react";

import { ViewEvent } from "#app/lib/analytics";
import { useWorkspace, type EntityViewRow } from "#app/lib/data";
import { copyText } from "#app/lib/utils/copy-actions";
import { useViews } from "#app/lib/views/view-context";
import { viewHref } from "#app/lib/utils/entity-hrefs";

/**
 * "Copy link to view": the view's absolute URL onto the clipboard, toasted.
 * ONE builder for every surface that offers it (the tab menu, the Customize
 * view panel), so the two can never copy different links. A `null` view (the
 * panel between views) yields a no-op so the hook can run before the host's
 * own early return.
 */
export function useCopyViewLink(view: EntityViewRow | null, via: string) {
  const { scope, trackView } = useViews();
  const { activeWorkspace } = useWorkspace();
  return useCallback(() => {
    if (!view) return;
    void copyText(
      viewHref(activeWorkspace?.urlPath ?? "", scope, view),
      "Link",
    ).then((ok) => {
      if (ok) trackView(ViewEvent.CopyLink, view, { via });
    });
  }, [activeWorkspace?.urlPath, scope, trackView, via, view]);
}
